import { OverrideValues } from "../components/ColumnOverrideForm";

export function extractOverrideErrors(reason: unknown, translate: (key: string) => string): Partial<Record<keyof OverrideValues, string>> {
    const details = (reason as any)?.response?.data?.error?.details;
    if (!details || typeof details !== "object") return {};
    const result: Partial<Record<keyof OverrideValues, string>> = {};
    for (const field of ["label", "is_mandatory", "is_read_only", "default_value_type", "default_value", "default_value_script", "default_value_timeout_ms", "reference_filter", "depends_on_column_id"] as const) {
        const raw = details[field];
        const first = Array.isArray(raw) ? raw[0] : raw;
        if (typeof first === "string" && first) result[field] = translate(first);
    }
    return result;
}
